import HeroSection from '../components/home/HeroSection'

function Home() {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
    </div>
  )
}

export default Home
